// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"499":"Download","594":"about","962":"home"}[chunkId] || chunkId) + "." + {"499":"0e0d0048","594":"a7843ba7","828":"a9667d4d","962":"4f89dfed"}[chunkId] + ".js";
};